export default {
  FETCH_LICENSE_RENEWAL_REQUEST: 'FETCH_LICENSE_RENEWAL_REQUEST',
  FETCH_LICENSE_RENEWAL_SUCCESS: 'FETCH_LICENSE_RENEWAL_SUCCESS',
  FETCH_LICENSE_RENEWAL_FAILURE: 'FETCH_LICENSE_RENEWAL_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/license-renewal/action-types.js